import DefaultLayout from "../../components/layout/DefaultLayout";
import FormBlocContainer from "../../components/layout/form/FormBlocContainer";
import React from "react";
import { useLocation } from 'react-router-dom';
import {Box, Divider, Typography, Grid } from "@mui/material";
import SubCard from '../../components/berry/ui-component/cards/SubCard';

const VerifyEmailInformPage = (props) => {
    const location = useLocation(); // Get location using the hook

    return (
        <DefaultLayout>
            <Box sx={{p: 2, bgcolor: 'transparent', borderRadius: '8px', width: '100%'}}>
                <Typography variant="h2" sx={{fontWeight: 'bold'}}>
                    Bravo ! <br />Une dernière validation e-mail.
                </Typography>
                <Divider   sx={{
                    borderColor: '#EF595D',
                    my: 1,
                    width: '20%',
                    borderWidth: '2px',
                    marginBottom: '15px',
                    marginTop: '15px'
                }} />
                <Typography sx={{ fontSize: '16px' }}>

                </Typography>
            </Box>

            {
                location.state &&
                <Grid container sx={{ marginTop: 3 }}>
                    <FormBlocContainer>
                        <Grid item xs={0} sm={2}></Grid>
                        <Grid item xs={12} sm={8}>
                        <SubCard>
                        <Grid item xs={12}>
                            <Typography variant="h2" sx={{fontWeight: 'bold'}}>
                                Informations
                            </Typography>

                        </Grid>
                        <Grid item xs={12}>
                            <p style={{ textAlign: 'justify' }}>
                                Un e-mail contenant un lien de validation a été envoyé à l'adresse suivante
                                : <b>{location.state.email}</b>.
                                <br/>
                                <br/>
                                Ce lien est valide pendant <b>{location.state.linkDuration} heures</b>.
                                <br/>
                                Si vous ne trouvez pas cet e-mail, pensez à vérifier dans vos courriers <b>indésirables
                                (spams)</b>.
                            </p>
                        </Grid>
                        </SubCard>
                        </Grid>
                    </FormBlocContainer>
                </Grid>
            }
        </DefaultLayout>
    );
}

export default VerifyEmailInformPage;
